import { render } from "./v-slider.vue?vue&type=template&id=d9e89bce&scoped=true"
import script from "./v-slider.vue?vue&type=script&lang=js"
export * from "./v-slider.vue?vue&type=script&lang=js"

import "./v-slider.vue?vue&type=style&index=0&id=d9e89bce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e89bce"],['__file',"src/Goya/components/Includes/v-slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9e89bce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9e89bce', __exports__)) {
    api.reload('d9e89bce', __exports__)
  }
  
  module.hot.accept("./v-slider.vue?vue&type=template&id=d9e89bce&scoped=true", () => {
    api.rerender('d9e89bce', render)
  })

}


export default __exports__